import { Navigate } from 'react-router-dom';

import { FormWrapper, Main, PageWrapper } from '../login/index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import UnlockForm from './unlock_form';

import useLocationParams from '../../../hooks/useLocationParams';

import type { User } from '@rewardopl/types';

export default function UnlockPage() {
  const [params] = useLocationParams() as [{ id?: User['_id']; token?: string }, () => void];

  const { id, token } = params;

  const hasParams = id && token;

  if (!hasParams) {
    return <Navigate to="/login" />;
  }

  return (
    <PageWrapper>
      <Header />
      <FormWrapper>
        <Main>
          <Heading align="center">Unlock account</Heading>
          <UnlockForm id={id} token={token} />
        </Main>
      </FormWrapper>
      <Footer />
    </PageWrapper>
  );
}
